import { apiAuth, apiResponseType } from ".";

export const getSellerDistributionBalances = (sellerId: number) => {
  return apiAuth.get(
    `distributions/seller-balances?seller_id=${sellerId}`
  ) as apiResponseType;
};

export const storeDistributionsSellerToSeller = (
  //@ts-ignore
  contestId: string,
  data: {
    contest_id: number;
    lottery_id: number;
    contest_product_classification_id: number;
    from_seller_id: number;
    sellers: { id: number; quota_quantity: number }[];
  }
) => {
  return apiAuth.post(
    `distributions/seller-balances/distribution-between-sellers`,
    data
  ) as apiResponseType;
};

export const storeDistributionsSellerToSellerWithFiles = (
  data: FormData
) => {
  return apiAuth.post(
    `distributions/seller-balances/distribution-between-sellers`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  ) as apiResponseType;
};

export const storeDistributionsSellerToUnity = (
  data: {
    contest_id: number;
    lottery_id: number;
    contest_product_classification_id: number;
    from_seller_id: number;
    unities: { id: number; quota_quantity: number }[];
  }
) => {
  return apiAuth.post(
    `distributions/seller-balances/distribution-seller-for-unity`,
    data
  ) as apiResponseType;
};

export const storeDistributionsSellerToUnityWithFiles = (
  data: FormData
) => {
  return apiAuth.post(
    `distributions/seller-balances/distribution-seller-for-unity`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  ) as apiResponseType;
};